import { Component, inject } from '@angular/core';
import { Observable, tap } from 'rxjs';
import { NotificationMessageService } from './notification-message.service';
import { NotificationMessage } from './notification-message.model';
import { CommonModule } from '@angular/common';
import { SafePipe } from '../pipes/safe.pipe';
import { AlertModule } from 'ngx-bootstrap/alert';

@Component({
    selector: 'app-notification-message',
    imports: [CommonModule, SafePipe, AlertModule],
    templateUrl: './notification-message.component.html',
    styleUrls: ['./notification-message.component.css']
})
export class NotificationMessageComponent {
	private readonly notificationMessageService = inject(NotificationMessageService);

	readonly message$: Observable<NotificationMessage> = this.notificationMessageService.messageSubject.pipe(
		tap(message => {
			if (message.show && message.scrollToTop)
				window.scrollTo(0, 0);
		})
	);

	close() {
		this.notificationMessageService.closeNotification();
	}
}
